var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 30,
    viewBox: "0 0 56 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8285 10.6998C31.5546 10.6998 33.7646 8.48976 33.7646 5.76358C33.7646 3.0374 31.5546 0.827393 28.8285 0.827393C26.1023 0.827393 23.8923 3.0374 23.8923 5.76358C23.8923 8.48976 26.1023 10.6998 28.8285 10.6998Z",
    fill: "#BEC6CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4696 28.9611L17.4325 9.8507L29.7267 24.3536L40.1516 14.0028L55.0729 29.066L2.4696 28.9611Z",
    fill: "#E8EBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9039 10.3493C25.1009 10.3493 22.8211 8.03404 22.8211 5.17389C22.8211 2.31374 25.1009 0 27.9039 0C30.707 0 32.9883 2.31528 32.9883 5.17389C32.9883 8.03249 30.707 10.3493 27.9039 10.3493ZM27.9039 0.456881C25.3525 0.456881 23.2734 2.57305 23.2734 5.17389C23.2734 7.77472 25.3479 9.89244 27.9039 9.89244C30.46 9.89244 32.5345 7.77627 32.5345 5.17389C32.5345 2.57151 30.4554 0.456881 27.9039 0.456881Z",
    fill: "#183243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 28.8607L15.4137 8.9493L27.2494 23.4785L37.3332 13.4456L37.4953 13.5999C38.0927 14.1942 46.9432 23.0324 48.0808 24.1746L47.7567 24.4957C47.1655 23.9029 44.4967 21.2373 41.5671 18.3108L37.3317 14.0892L27.5396 23.8335L31.4385 28.6184L31.0851 28.907L15.4245 9.69018L0.361245 29.1386L6.10352e-05 28.8607Z",
    fill: "#183243"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.0729,
    height: 29.1417,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotos);
export default __webpack_public_path__ + "static/media/photos.2f77f67458b5b6c3fdf819b6249c941e.svg";
export { ForwardRef as ReactComponent };